import { Table, notification, ConfigProvider, Spin, Row, Col } from "antd";
import NoPosition from "../../assets/vectors/NoPositionVector.png";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import { useEffect, useRef, useState } from "react";
import { ColumnType, ColumnsType, TableProps } from "antd/es/table";

import { ColorPalette } from "../share/color/colorPalette";
import faIR from "antd/lib/locale/fa_IR";
import { GetInvitationsOData } from "../../services/InvitationODataSevice";
import { Card } from "@material-ui/core";
import TedInvitationSideBarCompanyIcon from "../icons/TedInvitationSideBarCompanyIcon";
import ClockIcon from "../icons/NoticeCard/ClockIcon";
import TedOneLineChatIcon from "../icons/TedOneLineChatIcon";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { GetCollaboratorsOData } from "../../services/CollaboratingCompanyService";
import { GetCompanyParticipantCountByCompanyIdAndParticipantId } from "../../services/TransactionParticipantsService";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";

const Collaborators = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParamsd = location.search; // Get query string (e.g., "?Add")  // Check if "Add" exists in the query parameters
  // Start Of Checking User Has Position
  const [clientHeight, setClientHeight] = useState(0);
  const [clientWidth, setClientWidth] = useState(0);
  const locale = {
    ...faIR,
    Pagination: {
      ...faIR.Pagination,
      items_per_page: "ردیف",
      prev_page: "صفحه قبلی",
      next_page: "صفحه بعدی",
      jump_to: "برو به",
      page: "صفحه",
    },
  };
  // End Of Checking
  //asp
  useEffect(() => {
    setClientHeight(document.documentElement.clientHeight); // Get clientHeight of the element
    setClientWidth(document.documentElement.clientWidth);

    LoadCollaborators(pagination.current, pagination.pageSize);

    const handleResize = () => {
      setClientWidth(document.documentElement.clientWidth);
      setClientHeight(document.documentElement.clientHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    console.log("isAddPresent", searchParamsd);
  }, [searchParamsd]);
  //PaginationStart
  const [pagination, setPagination] = useState<any>({
    current: 1,
    pageSize: 20,
    total: 0,
  });

  //PaginationEnd

  //Notifications Start
  const [api, contextHolder] = notification.useNotification();

  //Notifications End

  const [GetCollabratorsData, SetCollabratorsData] = useState<any>(null);
  const [GetInvitationLoading, SetInvitaionLoading] = useState<any>(null);

  const handleTableChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
    let newSortField = null;
    let newSortOrder = null;

    if (!Array.isArray(sorter)) {
      newSortField = sorter.field as string;
      newSortOrder = sorter.order || null;
    }

    setSortField(newSortField);
    setSortOrder(newSortOrder);

    LoadCollaborators(
      pagination.current!,
      pagination.pageSize!,
      newSortField,
      newSortOrder
    );
  };
  const [isRowClicked, setIsRowClicked] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [sortOrder, setSortOrder] = useState<string | null>(null);
  const [sortField, setSortField] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [getSelectedCompanyParticipantId, setSelectedCompanyParticipantId] =
    useState<any>(null);

  const [getSelectedCompanyParticipantData, setSelectedCompanyParticipantData] =
    useState<any>(null);

  useEffect(() => {
    if (getSelectedCompanyParticipantData) {
      console.log(
        "getSelectedCompanyParticipantData",
        getSelectedCompanyParticipantData
      );
    }
  }, [getSelectedCompanyParticipantData]);

  useEffect(() => {
    if (getSelectedCompanyParticipantId) {
      GetCompanyParticipantCountByCompanyIdAndParticipantId(
        getSelectedCompanyParticipantId
      ).then((p) => {
        console.log("getSelectedCompanyParticipantId", p);
        setSelectedCompanyParticipantData(p?.data?.data);
      });
    }
  }, [getSelectedCompanyParticipantId]);

  const [searchParams] = useSearchParams();
  useEffect(() => {
    LoadCollaborators();
  }, [searchParams]);
  const LoadCollaborators = (
    page: number = pagination.current,
    pageSize: number = pagination.pageSize,
    sortFieldParam: string | null = sortField,
    sortOrderParam: string | null = sortOrder
  ) => {
    setLoading(true);

    const skip = (page - 1) * pageSize; // Offset
    const top = pageSize; // Limit

    let orderBy = "$orderby=CreatedDate desc";

    if (sortFieldParam && sortOrderParam) {
      orderBy = `$orderby=${sortFieldParam} ${
        sortOrderParam === "ascend" ? "asc" : "desc"
      }`;
    }
    const filterConditions: string[] = [];
    searchParams.forEach((value, key) => {
      if (
        !["page", "pageSize", "sortField", "sortOrder", "tab"].includes(key)
      ) {
        filterConditions.push(`contains(${key}, '${value}')`);
      }
    });
    const otherQuery = filterConditions.length
      ? `$filter=${filterConditions.join(" and ")}`
      : "";
    try {
      GetCollaboratorsOData(top, skip, orderBy, otherQuery)
        .then((response) => {
          setPagination((prev: any) => ({
            ...prev,
            current: page,
            pageSize,
            total: response?.data["@odata.count"],
          }));
          const dataWithKey = response?.data?.value?.map((item: any) => ({
            ...item,
            key: item.Id,
          }));
          SetCollabratorsData(dataWithKey);
          setLoading(false);
        })
        .then(() => {
          SetInvitaionLoading(false);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    console.log("ODD", GetCollabratorsData);
  }, [GetCollabratorsData]);
  // Load Invitations End

  //Search and Filter Operations Start
  interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
  }

  //Table Column Start
  const columnsTotal: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "5%",
      hidden: false,

      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: "عنوان فروشگاه",
      dataIndex: "CompanyName",
      key: "CompanyName",
      width: "15%",
      align: "right",
      onHeaderCell: () => ({
        style: {
          height: "52px",
          verticalAlign: "middle",
          textAlign: "center",
        },
      }),
      sorter: false,
      sortDirections: ["descend", "ascend"],
      render: (item, record, index) => <>{record?.CollaboratorCompany?.Name}</>,
    },
    {
      title: "نوع همکاری",
      dataIndex: "InvitationStatus",
      key: "InvitationStatus",
      width: "5%",
      align: "center",
      onHeaderCell: () => ({
        style: {
          height: "52px",
          verticalAlign: "middle",
          textAlign: "center",
        },
      }),

      render: (item, record, index) => <>{record.CollaborationModeString}</>,
      sorter: false,
      sortDirections: ["descend", "ascend"],
    },
  ];
  //Table Column End

  return (
    <>
      {contextHolder}

      {getMyPosition !== null ? (
        <>
          <div
            className="col-12 "
            style={{
              display: "inline-flex",

              backgroundColor: "transparent",
            }}
          >
            <div
              dir="rtl"
              className="mt-2 ag-theme-alpine"
              style={{
                float: "right",
                display: "flex",
                width: isRowClicked ? "69%" : "99%",
                marginRight: "10px",
                margin: "auto",
                height: clientHeight - 210,
                overflow: "scroll",
                backgroundColor: "transparent",
                transition: "width 0.3s ease-in-out",
              }}
            >
              <ConfigProvider locale={locale} direction="rtl">
                <Table
                  loading={{
                    spinning: loading,
                    indicator: <Spin size="large" />,
                  }}
                  size="small"
                  scroll={{ y: clientHeight - 355 }}
                  dataSource={GetCollabratorsData}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    pageSizeOptions: ["10", "15", "20"],
                    showSizeChanger: true, // Show page size changer
                    showTotal: (total, current) =>
                      `  ${current[0]}  الی ${current[1]} از ${pagination.total}`, // Show total count of rows
                    position: ["bottomRight"], // Position of the pagination
                    style: { marginRight: "10px" },
                    className: "custom-pagination",
                  }}
                  onRow={(record: any) => ({
                    onClick: () => {
                      console.log(
                        "Selected Row Data:",
                        record.CollaboratorCompanyId
                      ); // Log row data
                      setSelectedRow(record); // Store selected row data
                      setIsRowClicked(true); // Open the side div
                      setSelectedCompanyParticipantId(
                        record.CollaboratorCompanyId
                      );
                    },
                  })}
                  columns={columnsTotal}
                  onChange={handleTableChange}
                  style={{
                    border: "1px solid #d9d9d9",
                    borderRadius: "5px",
                    overflow: "scroll",

                    fontFamily: "YekanBakhVF",
                    transition: "opacity 0.3s ease-in-out",

                    marginBottom: "16px",
                  }}
                />
              </ConfigProvider>
            </div>
            {isRowClicked && (
              <Card
                className="mt-2"
                style={{
                  width: "30%",
                  margin: "auto",
                  marginBottom: "16px",
                  height: clientHeight - 197,
                  borderRadius: "5px",
                  border: "1px solid #D9D9D9",
                  transition: "opacity 0.3s ease-in-out",
                }}
              >
                <div
                  style={{
                    padding: "16px",
                    background: "#fafafa",
                    height: "52px",
                    borderRadius: "5px 5px 0px 0px",
                    borderBottom: "1px solid #D9D9D9",
                    transition: "opacity 0.3s ease-in-out",
                  }}
                >
                  <div style={{ display: "inline" }}>
                    <span>
                      <TedInvitationSideBarCompanyIcon />
                    </span>
                    <span
                      className="mx-2"
                      style={{
                        fontSize: "14px",
                        fontWeight: 450,
                        color: ColorPalette.primaryBlue[500],
                        lineHeight: "25.2px",
                      }}
                    >
                      {selectedRow?.CollaboratorCompany.Name}
                    </span>
                  </div>
                  <div style={{ display: "inline", float: "left" }}>
                    <span
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: 450,
                        color: ColorPalette.primaryBlue[500],
                        lineHeight: "25.2px",
                      }}
                      onClick={() => setIsRowClicked(false)}
                    >
                      بستن
                    </span>
                  </div>
                  <div>
                    <div
                      style={{
                        borderRadius: "8px",
                        marginTop: "2rem",
                        height: "55px",
                        textAlign: "right",
                        color: ColorPalette.gray[800],
                        fontSize: "14px",
                        fontWeight: 325,
                        lineHeight: "25.2px",
                        verticalAlign: "middle",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        backgroundColor: ColorPalette.primaryBlue[50],
                      }}
                    >
                      <span className="mx-3">آمار تعاملات :</span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "block",
                      width: "100%",
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      تعداد کل :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {getSelectedCompanyParticipantData?.transactionsCount}
                    </span>
                  </div>
                  <br />
                  <div
                    style={{
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      تعداد معاملات باز:
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {getSelectedCompanyParticipantData?.openTransactionsCount}
                    </span>
                  </div>
                  <br />
                  <div
                    style={{
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      تاریخ آخرین معامله :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {ConvertToShamsi(
                        getSelectedCompanyParticipantData?.lastTransactionDate
                      )}
                    </span>
                  </div>
                  <br />
                  <div
                    style={{
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      سابقه همکاری :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {getSelectedCompanyParticipantData?.collaborationDuration}
                      {" روز "}
                    </span>
                  </div>
                  <div>
                    <div
                      className="mt-5"
                      style={{
                        borderRadius: "8px",
                        marginTop: "2rem",
                        height: "55px",
                        textAlign: "right",
                        color: ColorPalette.gray[800],
                        fontSize: "14px",
                        fontWeight: 325,
                        lineHeight: "25.2px",
                        verticalAlign: "middle",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        backgroundColor: ColorPalette.primaryBlue[50],
                      }}
                    >
                      <span className="mx-3"> افراد مرتبط :</span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "block",
                      width: "100%",
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      امیرمهدی موسی زاده :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      09058129495
                    </span>
                  </div>
                  <br />
                  <div
                    style={{
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      نگین روشن :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      09121234567
                    </span>
                  </div>

                  <div>
                    <div
                      className="mt-5"
                      style={{
                        borderRadius: "8px",
                        marginTop: "2rem",
                        height: "55px",
                        textAlign: "right",
                        color: ColorPalette.gray[800],
                        fontSize: "14px",
                        fontWeight: 325,
                        lineHeight: "25.2px",
                        verticalAlign: "middle",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        backgroundColor: ColorPalette.primaryBlue[50],
                      }}
                    >
                      <span className="mx-3"> آگهی های باز :</span>
                    </div>
                  </div>
                  <>
                    <Row
                      style={{
                        fontFamily: "YekanBakhVF",
                        textAlign: "center",
                        height: "182px",
                        marginTop: "16px",
                        marginLeft: "10px",
                        //zIndex: -99,
                      }}
                    >
                      <Col
                        //onClick={() => navigate(`/notice/${notice.id}`)}
                        style={{
                          borderBottom: "1px solid #DDE1E6",
                          width: "100%",

                          marginRight: "12px",
                          cursor: "pointer",
                        }}
                      >
                        <Row
                          style={{
                            textAlign: "center",
                            marginTop: "16px",
                            backgroundColor: "transparent",
                          }}
                        >
                          <Col
                            style={{
                              width: "95%",
                              height: "150px",
                              backgroundColor: "transparent",
                              margin: "auto",
                            }}
                          >
                            <Row>
                              <Col
                                style={{ width: "100%", overflow: "hidden" }}
                              >
                                <Row
                                  style={{
                                    textAlign: "right",
                                    height: "50px",
                                    paddingTop: "8px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <Col
                                    style={{
                                      fontFamily: "YekanBakhVF",
                                      height: "50px",
                                    }}
                                  >
                                    دستگاه برش لیزر و حکاکی فلزات
                                  </Col>
                                </Row>
                                <Row style={{ height: "22px" }}>
                                  <Col
                                    style={{
                                      color: ColorPalette.gray[700],
                                      fontFamily: "YekanBakhVF",
                                    }}
                                  >
                                    صنعتی
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    width: "100%",
                                    color: ColorPalette.gray[500],
                                    marginTop: "20px",
                                  }}
                                >
                                  <Col
                                    style={{
                                      width: "100%",
                                    }}
                                  >
                                    <Row
                                      style={{
                                        textAlign: "right",
                                      }}
                                    >
                                      <Col style={{ paddingLeft: "5px" }}>
                                        <ClockIcon />
                                      </Col>
                                      <Col style={{ width: "23rem" }}>
                                        بیست ساعت پیش
                                      </Col>
                                      <Col
                                        style={{
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        <Row style={{ textAlign: "left" }}>
                                          <Col style={{ width: "1rem" }}>
                                            <TedOneLineChatIcon />
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                </div>
              </Card>
            )}
          </div>
        </>
      ) : (
        <>
          {" "}
          <div
            className="mt-5 iran"
            style={{ textAlign: "center", margin: "auto" }}
          >
            <p>کاربر گرامی شما دارای هیچ سمتی در هیچ فروشگاهی نمیباشید . </p>
            <img height={300} width={300} src={NoPosition} />
          </div>
        </>
      )}
    </>
  );
};
export default Collaborators;
